import React from "react";

const BlankPage = () => {
  return <div style={{ backgroundColor: "#000", height: "1440px" }}></div>;
};

export default BlankPage;
